import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { selectTopicsListItems } from "../../../../../../redux/chapter/topics/selector";
import { topics } from "../../../../../../redux/chapter/topics/action";


const Topics = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const TopicsItems = useSelector(selectTopicsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      {
        field: 'Subject', headerName: 'Subject', searchField: 'Subject', filter: true,
        filterType: 'text'
      },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },



    ]);
  }


  const handleSearch = (data: any) => {

    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Subject",
        FieldText: "Subject",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(topics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/list`, entity: 'topics', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

const fetchTopics = () => {
    dispatch(topics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/list`, entity: 'topics', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",


      }
    }))
  }

  const handleReloadData = () => {
   
    fetchTopics()
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  
  const handleAdd = () => {
    navigate(`${0}`);
  };

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Forum Topics</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];
  useEffect(() => {
    createColumnDefs()
    fetchTopics()
  }, [pageData, pageSize])
  const handleDelete = (data: any) => {
    dispatch(topics.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topics/delete`,
      entity: 'topics',
      jsonData: {
        Context: {},

        Records: [
          {

            Id: data?.Id
          }

        ]
      }
    })).then(() => {
     fetchTopics()
    });
  }
  return (
    <>
      {TopicsItems?.isLoading ? <PageLoader /> :
        <Table enableFilter={true}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs} rowData={TopicsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={TopicsItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Feeds" />

      }
    </>
  );
};

export default Topics;